import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  NzFormControlComponent,
  NzFormItemComponent,
  NzFormLabelComponent,
  NzFormModule,
} from 'ng-zorro-antd/form';
import { CommonModule } from '@angular/common';
import { NzInputModule } from 'ng-zorro-antd/input';
import { finalize, Observable, of, Subject, take, takeUntil } from 'rxjs';
import { DrawerService } from '../../../../../../../core/services/drawer.service';
import { DRAWER_IDS } from '../../../../../../../core/constants/drawer-ids.constant';
import { FrequencyDrawerParams } from '../../../insights-data.interface';
import { ErrorResponse } from '../../../../../../../core/models/error.models';
import { CommonService } from '../../../../../../../shared/services/common.service';
import { LoaderService } from '../../../../../../../core/services/loader.service';
import { InsightsDataService } from '../../../insights-data.service';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { AllowOnlyValidNumbersDirective } from '../../../../../../../core/direactives/allowedOnlyValidNUmber.directive';
import _ from 'lodash';
@Component({
  selector: 'app-frequency-only',
  standalone: true,
  imports: [
    NzFormModule,
    NzFormItemComponent,
    NzFormLabelComponent,
    NzFormControlComponent,
    NzInputModule,
    CommonModule,
    NzButtonModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    AllowOnlyValidNumbersDirective,
    NzSpinModule,
  ],
  providers: [provideNgxMask()],
  templateUrl: './frequency-only.component.html',
  styleUrl: './frequency-only.component.scss',
})
export class FrequencyOnlyComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  drawerParmas: FrequencyDrawerParams = {} as FrequencyDrawerParams;
  frquencyIntervalForm!: FormGroup;
  loading$: Observable<boolean> = of(false);

  constructor(
    private fb: FormBuilder,
    private drawerService: DrawerService,
    private commonService: CommonService,
    private loaderService: LoaderService,
    private insightsService: InsightsDataService
  ) {
    this.loading$ = this.loaderService.loading$;
    this.frquencyIntervalForm = this.fb.group({
      id: [0],
      frequency: [''],
    });
    this.setupDrawerSubscription();
  }

  private setupDrawerSubscription(): void {
    this.drawerService
      .getParams<FrequencyDrawerParams>(DRAWER_IDS.FREQUENCY)
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.drawerParmas = params;
          if (this.drawerParmas.selectedRow.isFrequencyOnly) {
            const matchedData = _.find(
              this.drawerParmas.behaviorData.activityDataUnitValues,
              { dataDate: this.drawerParmas.selectedDate }
            );
            if (matchedData) {
              this.frquencyIntervalForm.patchValue({
                id: matchedData.id,
                frequency: matchedData.blockValue,
              });
            }
          } else {
            if (this.drawerParmas.selectedRow.totalFrequency) {
              this.frquencyIntervalForm.patchValue({
                frequency: this.drawerParmas.selectedRow.totalFrequency,
              });
            }
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  submitForm() {
    const payload = {
      unitId: this.drawerParmas.unitId,
      blockValues: [
        {
          id: this.frquencyIntervalForm.value.id,
          dataDate: this.drawerParmas.selectedDate,
          unitValue: this.frquencyIntervalForm.value.frequency,
        },
      ],
    };
    this.loaderService.show();
    const operation$ = this.insightsService.saveBlockValue(payload);

    operation$
      .pipe(
        take(1),
        takeUntil(this.destroy$),
        finalize(() => {
          this.loaderService.hide();
        })
      )
      .subscribe({
        next: () => {
          this.commonService.notify('success', `Datasheet saved successfully`);
          this.onCancel();
        },
        error: error => {
          this.loaderService.hide();
          this.handleError(error);
        },
      });
  }

  private handleError({ errors, message }: ErrorResponse): void {
    const errorMessages = errors.map(
      err => err.description || err.detailedMessage
    );
    this.commonService.notify('error', errorMessages, message);
  }

  onCancel() {
    this.drawerService.closeDrawer(DRAWER_IDS.FREQUENCY);
  }
}
